export default /* @ngInject */ function($log, $timeout) {
    return {
        restrict: 'A',
        link: function(scope, element) {
            $timeout(() => {
                if (element.prop('tagName') === 'INPUT') {
                    try {
                        let end = element[0].value.length;
                        element[0].focus();
                        element[0].setSelectionRange(end, end);
                    } catch (err) {
                        $log.warn('Cannot focus element', element[0]);
                    }
                }
            });
        }
    };
}



// WEBPACK FOOTER //
// ./forms/directives/autofocus.js